export { execute } from 'next-flight-server-reference-proxy-loader?id=70b7a06bfb182b522eda9f21f16bbb0d9ba880aab1&name=execute!'